import React from 'react';
import styled from 'styled-components';

const PatientFormHeaderComponent = styled.div`
  color: ${(props) => props.theme.palette.text.primary};
  font-size: 1.25em;
  padding-right: 5px;
  padding-top: 1px;
  padding-bottom: 1px;
`;

export const PatientFormHeader = ({ formData }: any) => {
  const { patientfirstname, patientlastname, patientnumber } = formData as any;
  return (
    <PatientFormHeaderComponent>
      {`${patientfirstname} ${patientlastname} - ${patientnumber}`}
    </PatientFormHeaderComponent>
  );
};
